import { GroupedBuyerCard } from "./GroupedBuyerCard";

export default GroupedBuyerCard;
